import { getAction, postAction, putAction, deleteAction, uploadAction } from '@/api/manage'
import { axios } from '@/utils/request'

/**
 * 餐饮插件（dining-plugin）API 封装
 * 契约来源：plugins/dining-plugin/src/main/java/com/jsh/plugin/dining/controller/*Controller.java
 * 返回结构统一 {code, success, message, data}
 */
const PREFIX = '/api/plugin/dining'

// ==================== 门店（Task 1A） ====================

export const storeList = (params) => getAction(`${PREFIX}/store/list`, params)
export const storeAdd = (data) => postAction(`${PREFIX}/store`, data)
export const storeUpdate = (id, data) => putAction(`${PREFIX}/store/${id}`, data)
export const storeDelete = (id) => deleteAction(`${PREFIX}/store/${id}`)
export const storeOptions = () => getAction(`${PREFIX}/store/options`)
export const storeBindUsers = (id, data) => putAction(`${PREFIX}/store/${id}/users`, data)
export const storeMy = () => getAction(`${PREFIX}/store/my`)
export const storeUsers = (id) => getAction(`${PREFIX}/store/${id}/users`)

// ==================== 桌台区域/桌型/桌台（Task 2） ====================

export const areaList = (params) => getAction(`${PREFIX}/table-area/list`, params)
// 后端 POST 为 @RequestParam storeId(query) + @RequestBody(body) 分离，storeId 拼入 URL（数字，安全）
export const areaAdd = (storeId, data) => postAction(`${PREFIX}/table-area?storeId=${storeId}`, data)
export const areaUpdate = (id, data) => putAction(`${PREFIX}/table-area/${id}`, data)
export const areaDelete = (id) => deleteAction(`${PREFIX}/table-area/${id}`)

export const tableTypeList = (params) => getAction(`${PREFIX}/table-type/list`, params)
export const tableTypeAdd = (storeId, data) => postAction(`${PREFIX}/table-type?storeId=${storeId}`, data)
export const tableTypeUpdate = (id, data) => putAction(`${PREFIX}/table-type/${id}`, data)
export const tableTypeDelete = (id) => deleteAction(`${PREFIX}/table-type/${id}`)

export const tableList = (params) => getAction(`${PREFIX}/table/list`, params)
export const tableAdd = (storeId, data) => postAction(`${PREFIX}/table?storeId=${storeId}`, data)
export const tableUpdate = (id, data) => putAction(`${PREFIX}/table/${id}`, data)
export const tableDelete = (id) => deleteAction(`${PREFIX}/table/${id}`)
export const tableQr = (id) => getAction(`${PREFIX}/table/${id}/qr`)
export const tableWxacode = (id) => getAction(`${PREFIX}/table/${id}/wxacode`)
export const tablePrintData = (params) => getAction(`${PREFIX}/table/print-data`, params)
export const tableStatus = (id, data) => putAction(`${PREFIX}/table/${id}/status`, data)

// ==================== 菜品绑定与选项（Task 3） ====================

export const goodsList = (params) => getAction(`${PREFIX}/goods/list`, params)
export const goodsMaterialsOptions = (params) => getAction(`${PREFIX}/goods/materials-options`, params)
export const goodsAdd = (data) => postAction(`${PREFIX}/goods`, data)
export const goodsUpdate = (id, data) => putAction(`${PREFIX}/goods/${id}`, data)
export const goodsDelete = (id) => deleteAction(`${PREFIX}/goods/${id}`)

export const optionGroups = (goodsId) => getAction(`${PREFIX}/goods/${goodsId}/option-groups`)
export const optionGroupAdd = (data) => postAction(`${PREFIX}/goods/option-group`, data)
export const optionGroupUpdate = (id, data) => putAction(`${PREFIX}/goods/option-group/${id}`, data)
export const optionGroupDelete = (id) => deleteAction(`${PREFIX}/goods/option-group/${id}`)
export const optionValueAdd = (groupId, data) => postAction(`${PREFIX}/goods/option-group/${groupId}/values`, data)
export const optionValueUpdate = (id, data) => putAction(`${PREFIX}/goods/option-value/${id}`, data)
export const optionValueDelete = (id) => deleteAction(`${PREFIX}/goods/option-value/${id}`)

export const menuList = (params) => getAction(`${PREFIX}/goods/menu`, params)

// ==================== 餐饮订单（Task 4，管理端/收银台） ====================

export const orderCreate = (data) => postAction(`${PREFIX}/order`, data)
export const orderAddItems = (id, data) => postAction(`${PREFIX}/order/${id}/items`, data)
export const orderPark = (id) => putAction(`${PREFIX}/order/${id}/park`)
export const orderResume = (id) => putAction(`${PREFIX}/order/${id}/resume`)
export const orderCancel = (id) => putAction(`${PREFIX}/order/${id}/cancel`)
export const parkedList = (params) => getAction(`${PREFIX}/order/parked-list`, params)
export const orderList = (params) => getAction(`${PREFIX}/order/list`, params)
export const orderDetail = (id) => getAction(`${PREFIX}/order/${id}`)
export const orderPrintData = (id, printType) => getAction(`${PREFIX}/order/${id}/print-data`, { printType })
export const orderSettle = (id, data) => postAction(`${PREFIX}/order/${id}/settle`, data)
export const orderPayQrcode = (id, data) => postAction(`${PREFIX}/order/${id}/pay-qrcode`, data)
export const orderPayStatus = (params) => getAction(`${PREFIX}/order/pay-status`, params)
export const orderRefund = (id) => postAction(`${PREFIX}/order/${id}/refund`)
export const orderSetDiscount = (id, data) => putAction(`${PREFIX}/order/${id}/discount`, data)
// 退菜 {reason 必填}（仅未结算；已退行不计金额；触发 TCD 退菜单）
export const orderItemReturn = (id, itemId, data) => postAction(`${PREFIX}/order/${id}/item/${itemId}/return`, data)
// 整单清空=整单作废（必填备注走请求体；deleteAction 仅支持 query 参数，此处 axios 直发 body）
export const orderClearItems = (id, data) => axios({ url: `${PREFIX}/order/${id}/items`, method: 'delete', data })
export const orderBindMember = (id, data) => putAction(`${PREFIX}/order/${id}/member`, data)
export const orderDeposit = (id, data) => putAction(`${PREFIX}/order/${id}/deposit`, data)

// ==================== 外卖订单（Task 9/10，收银台订单视图外卖 Tab） ====================

export const takeoutList = (params) => getAction(`${PREFIX}/takeout-orders/list`, params)
export const takeoutDetail = (id) => getAction(`${PREFIX}/takeout-orders/${id}`)
export const takeoutReceive = (id) => postAction(`${PREFIX}/takeout-orders/${id}/receive`)
export const takeoutMealOut = (id) => postAction(`${PREFIX}/takeout-orders/${id}/meal-out`)
export const takeoutComplete = (id) => postAction(`${PREFIX}/takeout-orders/${id}/complete`)
export const takeoutVerifySelf = (id, data) => postAction(`${PREFIX}/takeout-orders/${id}/verify-self`, data)
export const takeoutPrintData = (id) => getAction(`${PREFIX}/takeout-orders/${id}/print-data`)

// ==================== 主体档案与地图服务（Task 1/2） ====================

export const tenantProfileGet = () => getAction(`${PREFIX}/tenant-profile`)
export const tenantProfileSave = (data) => putAction(`${PREFIX}/tenant-profile`, data)
export const tenantProfilePrefill = () => getAction(`${PREFIX}/tenant-profile/prefill`)
export const mapKey = () => getAction(`${PREFIX}/map/key`)
export const mapSearch = (params) => getAction(`${PREFIX}/map/search`, params)
// 逆地址解析：GET /map/geocoder?lat=&lng= → {address}（地图点选回填地址用）
export const mapGeocoder = (params) => getAction(`${PREFIX}/map/geocoder`, params)

// ==================== 门店租户化·阶段一（Task 3） ====================

export const userStoreBind = (userId, data) => putAction(`${PREFIX}/user/${userId}/store`, data)

// ==================== 装修页面（Task 6，管理端） ====================

export const decorList = () => getAction(`${PREFIX}/decor/list`)
export const decorDetail = (id) => getAction(`${PREFIX}/decor/${id}`)
export const decorAdd = (data) => postAction(`${PREFIX}/decor`, data)
export const decorUpdate = (id, data) => putAction(`${PREFIX}/decor/${id}`, data)
export const decorDelete = (id) => deleteAction(`${PREFIX}/decor/${id}`)
export const decorPublish = (id) => putAction(`${PREFIX}/decor/${id}/publish`)
export const decorUnpublish = (id) => putAction(`${PREFIX}/decor/${id}/unpublish`)

// ==================== 素材管理（图片库，对齐云贝 materialmange） ====================
// 上传统一走主工程 POST /systemConfig/upload（multipart：file + biz），biz 仅允许 bill/financial/material
export const mediaUpload = (formData) => uploadAction('/systemConfig/upload', formData)

export const mediaList = (params) => getAction(`${PREFIX}/media/list`, params)
export const mediaRegister = (data) => postAction(`${PREFIX}/media`, data)
export const mediaMove = (data) => putAction(`${PREFIX}/media/move`, data)
// 软删进回收站：DELETE /media/{ids}（ids 逗号串）
export const mediaRemove = (ids) => deleteAction(`${PREFIX}/media/${ids}`)
export const mediaRestore = (id) => putAction(`${PREFIX}/media/${id}/restore`)
// 彻底删除：ids 为空 = 清空回收站
export const mediaPurge = (ids) => deleteAction(`${PREFIX}/media/purge`, { ids: ids || '' })

export const mediaGroupList = () => getAction(`${PREFIX}/media-groups`)
export const mediaGroupAdd = (data) => postAction(`${PREFIX}/media-groups`, data)
export const mediaGroupUpdate = (id, data) => putAction(`${PREFIX}/media-groups/${id}`, data)
export const mediaGroupDelete = (id) => deleteAction(`${PREFIX}/media-groups/${id}`)

// ==================== 打印管理（dining-print-architecture Task 4/7） ====================

export const printerList = (params) => getAction(`${PREFIX}/print/printers`, params)
export const printerCreate = (data) => postAction(`${PREFIX}/print/printers`, data)
export const printerUpdate = (id, data) => putAction(`${PREFIX}/print/printers/${id}`, data)
export const printerDelete = (id) => deleteAction(`${PREFIX}/print/printers/${id}`)
// 测试打印：即时出实体样张（渲染测试单据走后端通道下发）
export const printerTest = (id) => postAction(`${PREFIX}/print/printers/${id}/test`)
export const stationList = (params) => getAction(`${PREFIX}/print/stations`, params)
export const stationCreate = (data) => postAction(`${PREFIX}/print/stations`, data)
export const stationUpdate = (id, data) => putAction(`${PREFIX}/print/stations/${id}`, data)
export const stationDelete = (id) => deleteAction(`${PREFIX}/print/stations/${id}`)
// 菜品批量分配档口 {materialIds:[..], stationId:null=清除}
export const goodsAssignStation = (data) => postAction(`${PREFIX}/print/goods/assign-station`, data)
export const gatewayList = (params) => getAction(`${PREFIX}/print/gateways`, params)
export const gatewayCreate = (data) => postAction(`${PREFIX}/print/gateways`, data)
// 生成一次性配对码（6 位数字，网关配对后失效）
export const gatewayPairCode = (id) => postAction(`${PREFIX}/print/gateways/${id}/pair-code`)
export const gatewayDelete = (id) => deleteAction(`${PREFIX}/print/gateways/${id}`)
// 打印日志：{storeId, billType?, status?, orderId?, pageNo, pageSize}
export const printLogList = (params) => getAction(`${PREFIX}/print/logs`, params)
// 补打（渲染快照重发，新 taskId）
export const printLogReprint = (id) => postAction(`${PREFIX}/print/logs/${id}/reprint`)
export const printTemplates = () => getAction(`${PREFIX}/print/templates`)
export const printTemplateSave = (billType, data) => putAction(`${PREFIX}/print/templates/${billType}`, data)
// 结算单静默直打 {printType: settle|pre_settle}（收银端 autoPrint 用，Task 9）
export const receiptPrint = (orderId, data) => postAction(`${PREFIX}/print/receipt/${orderId}`, data)
